type Identifiable = { _id: string; createdAt?: number };

/** Apply stored id order; unknown ids append at end (stable by createdAt when present). */
export function applyStoredOrder<T extends Identifiable>(
  items: T[],
  storedOrder: string[] | undefined,
): T[] {
  if (items.length === 0) return items;
  if (!storedOrder?.length) {
    return sortByCreatedAt(items);
  }

  const byId = new Map(items.map((item) => [item._id, item]));
  const orderSet = new Set(storedOrder);
  const ordered = storedOrder.filter((id) => byId.has(id)).map((id) => byId.get(id)!);
  const appended = sortByCreatedAt(items.filter((item) => !orderSet.has(item._id)));
  return [...ordered, ...appended];
}

function sortByCreatedAt<T extends Identifiable>(items: T[]): T[] {
  return [...items].sort((a, b) => (a.createdAt ?? 0) - (b.createdAt ?? 0));
}
